import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { environment } from "src/environments/environment";

@Injectable({
  providedIn: "root",
})
export class ComiteService {
  urlCatalogos: string = `${environment.apiCitas.context}${environment.apiCitas.methods.catalog}`;
  urlComite: string = `${environment.apiComite.context}`;
  urlComiteActive: string = `${environment.apiComite.context}${environment.apiComite.methods.active}`;

  constructor(private http: HttpClient) {}

  getComites(page: number, size: number, search?: string): Promise<any> {
    return this.http
      .get<any>(`${this.urlComiteActive}?size=${size}&page=${page}&search=${search}`)
      .toPromise();
  }

  getComitesDetail(id?: string): Promise<any> {
    return this.http.get<any>(`${this.urlComite}${id}`).toPromise();
  }

  getCatalogo(): Promise<any> {
    const requestOptions = { headers: new HttpHeaders({ 'content-type': "application/json" }) };
    return this.http.get<any>(this.urlCatalogos, requestOptions ).toPromise();
  }
}
